import { render } from "./NotificationCard.vue?vue&type=template&id=91c98354&ts=true"
import script from "./NotificationCard.vue?vue&type=script&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSpinnerDots,QTooltip});
